import { render, staticRenderFns } from "./WaterPrice.vue?vue&type=template&id=425cd368&scoped=true"
import script from "./WaterPrice.vue?vue&type=script&lang=js"
export * from "./WaterPrice.vue?vue&type=script&lang=js"
import style0 from "./WaterPrice.vue?vue&type=style&index=0&id=425cd368&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425cd368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('425cd368')) {
      api.createRecord('425cd368', component.options)
    } else {
      api.reload('425cd368', component.options)
    }
    module.hot.accept("./WaterPrice.vue?vue&type=template&id=425cd368&scoped=true", function () {
      api.rerender('425cd368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Basics/BasicsEnergyPrice/WaterPrice/WaterPrice.vue"
export default component.exports